import React, { FC, KeyboardEvent } from 'react';

import { Search } from '../../assets/index';
import Spinner from '../spinner/spinner';

import './SearchBar.scss';

interface Props {
  placeholder: string;
  onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onEnter?: (event: KeyboardEvent<HTMLInputElement>) => void;
  value?: string;
  onChange?: (event) => void;
  isLoading?: boolean;
}

const SearchBar: FC<Props> = ({
  placeholder,
  onKeyPress = () => {},
  onEnter = () => {},
  onChange = () => {},
  value,
  isLoading = false,
}) => {
  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    onKeyPress(event);
    if (event.key === 'Enter') {
      onEnter(event);
    }
  };

  return (
    <div className='searchbar-container'>
      <Search />
      <input
        type='text'
        placeholder={placeholder}
        className='searchbar'
        value={value}
        onKeyPress={handleKeyPress}
        onChange={evt => onChange(evt.target.value)}
      />
      {isLoading && <Spinner />}
    </div>
  );
};

export default SearchBar;
